// import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
export const InformationTrackerUploadGridConfig = {
    list: 'InformationTracker',
    grid: {
        gridId: 'InformationTrackerUploadGrid',
        checkbox: false,
        edit: false,
        delete: true,
        height: 500,
        pageSize: 10,
        groupable: false
    },
    columns: {
        InfoTrackerKey: {
            class: 'id',
            dataName: 'InfoTrackerKey',
            type: 'number',
            title: 'Id',
            width: 100,
            hidden: true,
            readOnly: false
        },
        Validation: {
            dataName: 'Validation',
            type: 'string',
            title: 'Validation',
            width: 130,
            hidden: false
        },
        // LastCompleted: {
        //     class: 'value',
        //     dataName: 'LastCompleted',
        //     type: 'date',
        //     title: 'Last Completed',
        //     width: 150,
        //     hidden: false
        // },
        PartnerTitle: {
            class: "lookup",
            dataName: 'Partner/FullName',
            type: 'string',
            title: 'Partner',
            width: 150,
            hidden: false,
            readOnly: true
        },
        ProgramTitle: {
            class: 'lookup',
            dataName: 'Program/Title',
            type: 'string',
            title: 'Program',
            width: 250,
            hidden: false,
            readOnly: true
        },
        PartnerPartnerId: {
            class: "value",
            dataName: 'PartnerId',
            type: 'number',
            title: 'Partner Id',
            width: 100,
            hidden: true,
            readOnly: false
        },
        ProgramProgramId: {
            class: "value",
            dataName: 'ProgramId',
            type: 'number',
            title: 'Program Id',
            width: 100,
            hidden: true,
            readOnly: false
        },
        SignaturePage: {
            class: "value",
            dataName: 'SignaturePage',
            type: 'string',
            title: 'Signature Page',
            width: 150,
            hidden: false,
            readOnly: false
        },
        Receive83b: {
            class: "value",
            dataName: 'Receive83b',
            type: 'string',
            title: '83(b)',
            width: 150,
            hidden: false,
            readOnly: false
        },
        Receive83bFiledWithIRS: {
            class: "value",
            dataName: 'Receive83bFiledWithIRS',
            type: 'string',
            title: '83(b) Filed With IRS',
            width: 150,
            hidden: false,
            readOnly: false
        },
        // AmountOwed: {
        //     class: "value",
        //     dataName: 'AmountOwed',
        //     type: 'number',
        //     title: 'Amount Owed',
        //     template: '#=kendo.toString(AmountOwed, "c")#',
        //     width: 125,
        //     hidden: false,
        //     readOnly: false
        // },
        Payment: {
            class: "value",
            dataName: 'Payment',
            type: 'number',
            title: 'Payment',
            width: 125,
            hidden: false,
            template: '<span class="number-cell-ui">#=kendo.toString(Payment, "c")#</span>',
            readOnly: false
        },
        MethodofPayment: {
            class: "value",
            dataName: 'MethodofPayment',
            type: 'string',
            title: 'Method of Payment',
            width: 150,
            hidden: false,
            readOnly: false
        },
        CheckNumber: {
            class: "value",
            dataName: 'CheckNumber',
            type: 'string',
            title: 'Check Number',
            width: 125,
            hidden: false,
            readOnly: false
        },
        DateDeposited: {
            class: "value",
            dataName: 'DateDeposited',
            type: 'date',
            title: 'Date Deposited',
            width: 125,
            hidden: false,
            readOnly: false
        },
        DateWired: {
            class: "value",
            dataName: 'DateWired',
            type: 'date',
            title: 'Date Wired',
            width: 125,
            hidden: false,
            readOnly: false
        }
    },
}